import storage from 'store';
import expirePlugin from 'store/plugins/expire';
import { login, getInfo, googleLogin } from '@/api/login';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { welcome } from '@/utils/util';

storage.addPlugin(expirePlugin);
const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name;
      state.welcome = welcome;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_INFO: (state, info) => {
      state.info = info;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            console.log('login response:', response);
            if (response.success) {
              const result = response.data;
              storage.set(ACCESS_TOKEN, result.accessToken, new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
              commit('SET_TOKEN', result.accessToken);
              resolve();
            } else {
              reject(new Error('用户名或密码错误'));
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    googleLogin({ commit }, token) {
      return new Promise((resolve, reject) => {
        googleLogin({ credential: token })
          .then((response) => {
            console.log('login response:', response);
            if (response.success) {
              const result = response.data.user;
              storage.set(ACCESS_TOKEN, response.data.accessToken, new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
              commit('SET_TOKEN', response.data.accessToken);
              resolve(result);
            } else {
              reject(new Error('用户名或密码错误'));
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        // 请求后端获取用户信息 /api/user/info
        getInfo()
          .then((response) => {
            // const { result } = response;
            if (response.success) {
              const result = response.data;
              commit('SET_INFO', result);
              commit('SET_NAME', { name: result.userName, welcome: welcome() });
              commit('SET_AVATAR', 'https://gw.alipayobjects.com/zos/rmsportal/jZUIxmJycoymBprLOUbT.png');
              commit('SET_ROLES', 'admin');
              // 下游
              resolve(result);
              // if (result.role && result.role.permissions.length > 0) {
              //   const role = { ...result.role };
              //   role.permissions = result.role.permissions.map((permission) => {
              //     const per = {
              //       ...permission,
              //       actionList: (permission.actionEntitySet || {}).map((item) => item.action),
              //     };
              //     return per;
              //   });
              //   role.permissionList = role.permissions.map((permission) => {
              //     return permission.permissionId;
              //   });
              //   // 覆盖响应体的 role, 供下游使用
              //   result.role = role;

              //   commit('SET_ROLES', role);
              //   commit('SET_INFO', result);
              //   commit('SET_NAME', { name: result.userName, welcome: welcome() });
              //   commit('SET_AVATAR', result.avatar);
              //   // 下游
              //   resolve(result);
              // }
            } else {
              reject(new Error('用户信息获取失败'));
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        storage.remove(ACCESS_TOKEN);
        resolve();
        // logout(state.token)
        //   .then(() => {
        //     resolve();
        //   })
        //   .catch((err) => {
        //     console.log('logout fail:', err);
        //     // resolve()
        //   })
        //   .finally(() => {});
      });
    },
  },
};

export default user;
